import { getValueByIdentifier } from '../tags/index';
import { ROBOTS_DIRECTIVES, isRobotsDirectiveExists, } from '../tags/robots-tag/robots-tag';
import { IDENTIFIERS } from '../types/Identifiers';
export var isIndexable = function (_a) {
    var tags = _a.tags, _b = _a.href, href = _b === void 0 ? '' : _b;
    var _c = [
        IDENTIFIERS.ROBOTS,
        IDENTIFIERS.CANONICAL,
    ].map(function (identifier) { return getValueByIdentifier(tags, identifier); }), robotsValue = _c[0], canonicalValue = _c[1];
    var shouldIndex = !robotsValue ||
        !isRobotsDirectiveExists(robotsValue, ROBOTS_DIRECTIVES.NOINDEX);
    var isCanonicalEqual = !canonicalValue || canonicalValue === href;
    return shouldIndex && isCanonicalEqual;
};
